import { FileText } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Belt } from "@/components/Belt";
import { Empty } from "@/components/common";
import { usePortal } from "@/components/PortalLayout";
import { useApi } from "@/lib/useApi";
import { downloadBlob } from "@/lib/api";
import { dt } from "@/lib/fmt";

export default function PortalGraduation() {
  const { sid } = usePortal();
  const [o] = useApi(`/portal/students/${sid}`, [sid]);
  const [promos] = useApi(`/graduation/promotions?student_id=${sid}`, [sid]);
  if (!o) return <Empty text="Carregando…" />;
  const n = o.next_step;
  return (
    <div className="space-y-4">
      <h1 className="text-3xl font-extrabold uppercase">Graduação</h1>
      <div className="panel p-5 space-y-3" data-testid="portal-grad-current">
        <div className="eyebrow">Faixa atual</div>
        <Belt belt={o.student.belt} grau={o.student.grau} size="lg" />
        <div className="font-display text-2xl font-bold uppercase">{o.student.belt} · {o.student.grau}º grau</div>
        {n && <div className="text-sm text-slate-600">Próximo passo: <b>{n.type === "grau" ? `${n.grau}º grau` : `faixa ${n.belt}`}</b> · critério da academia: {n.classes} aulas e {n.months} meses ({o.classes_since_promotion} aulas feitas). A decisão final é sempre do professor.</div>}
      </div>
      <div className="panel p-5" data-testid="portal-grad-history">
        <div className="font-display text-lg font-bold uppercase mb-3">Histórico</div>
        {(promos || []).map((p) => (
          <div key={p.id} className="flex items-center justify-between gap-3 py-3 border-t border-slate-100">
            <div><Belt belt={p.belt} grau={p.grau} size="sm" /><div className="text-sm font-semibold mt-1">{p.belt} {p.grau}º grau</div>
              <div className="text-xs text-slate-500">{dt(p.date)} · {p.professor_name}{p.event_name && ` · ${p.event_name}`}</div>
              {p.notes && <div className="text-xs text-slate-600 mt-1">{p.notes}</div>}</div>
            {p.certificate_file_id && <Button size="sm" variant="outline" onClick={() => downloadBlob(`/files/${p.certificate_file_id}`, "certificado", true)}><FileText className="w-4 h-4" /></Button>}
          </div>))}
        {!promos?.length && <Empty />}
      </div>
    </div>
  );
}
